var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.9995C7.173 8.9995 6.5 8.3265 6.5 7.4995C6.5 6.6725 7.173 5.9995 8 5.9995C8.827 5.9995 9.5 6.6725 9.5 7.4995C9.5 8.3265 8.827 8.9995 8 8.9995ZM8 3.9995C6.07 3.9995 4.5 5.5695 4.5 7.4995C4.5 9.4295 6.07 10.9995 8 10.9995C9.93 10.9995 11.5 9.4295 11.5 7.4995C11.5 5.5695 9.93 3.9995 8 3.9995ZM8 17.646C6.325 16.062 2 11.615 2 7.922C2 4.657 4.691 2 8 2C11.309 2 14 4.657 14 7.922C14 11.615 9.675 16.062 8 17.646ZM8 0C3.589 0 0 3.553 0 7.922C0 13.397 7.049 19.501 7.349 19.758C7.537 19.919 7.768 20 8 20C8.232 20 8.463 19.919 8.651 19.758C8.951 19.501 16 13.397 16 7.922C16 3.553 12.411 0 8 0Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.b47c201513b8daf2937fe33548c6c750.svg";
export { ForwardRef as ReactComponent };